import WizardFrame from '@/components/shared/WizardFrame.vue';
import AboutYourCompany from '@/views/AboutYourCompany.vue';
import AccountBeingSetup from '@/views/AccountBeingSetup.vue';
import BillingExpired from '@/views/BillingExpired.vue';
import CreatePassword from '@/views/CreatePassword.vue';
import DemoAboutYourCompany from '@/views/DemoAboutYourCompany.vue';
import DemoProvideYourWorkEmail from '@/views/DemoProvideYourWorkEmail.vue';
import DemoReady from '@/views/DemoReady.vue';
import DemoRequest from '@/views/DemoRequest.vue';
import DemoRequestHold from '@/views/DemoRequestHold.vue';
import DemoRequestReceived from '@/views/DemoRequestReceived.vue';
import DisabledUser from '@/views/DisabledUser.vue';
import IEDeprecated from '@/views/IEDeprecated.vue';
import JoinDashboard from '@/views/JoinDashboard.vue';
import Login from '@/views/Login.vue';
import Maintenance from '@/views/Maintenance.vue';
import MobileNotSupported from '@/views/MobileNotSupported.vue';
import PasswordReset from '@/views/PasswordReset.vue';
import PasswordResetSuccess from '@/views/PasswordResetSuccess.vue';
import ProjectNotAssigned from '@/views/ProjectNotAssigned.vue';
import ProvideWorkEmail from '@/views/ProvideWorkEmail.vue';
import SalesHold from '@/views/SalesHold.vue';
import Signup from '@/views/Signup.vue';
import SignupGate from '@/views/SignupGate.vue';
import SsoLocked from '@/views/SsoLocked.vue';
import TechnicalHold from '@/views/TechnicalHold.vue';
import TerminatedGeneric from '@/views/TerminatedGeneric.vue';
import TerminatedHrTech from '@/views/TerminatedHrTech.vue';
import TerminatedNoAts from '@/views/TerminatedNoAts.vue';
import TerminatedSuspended from '@/views/TerminatedSuspended.vue';
import TermsOfService from '@/views/TermsOfService.vue';
import TrialExpired from '@/views/TrialExpired.vue';
import TrialPaused from '@/views/TrialPaused.vue';
import TrialRenew from '@/views/TrialRenew.vue';
import VerifyEmail from '@/views/VerifyEmail.vue';

export const gatesAndLogin = [
  {
    path: '/',
    component: WizardFrame,
    children: [
      {
        path: '/signup',
        name: 'signup',
        component: Signup,
        meta: { authStateRequired: 'unauthenticated', title: 'Create a New Account' },
      },
      {
        path: '/provide-work-email',
        name: 'provide-work-email',
        props: true,
        component: ProvideWorkEmail,
        meta: { authStateRequired: 'unauthenticated', title: 'Provide Your Work Email' },
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { authStateRequired: 'unauthenticated', title: 'Log Into Your Account' },
      },
      {
        path: '/join-dashboard',
        name: 'join-dashboard',
        component: JoinDashboard,
        meta: { authStateRequired: 'unauthenticated', title: 'Create a New Account' },
      },
      {
        path: '/ie-deprecated',
        name: 'ie-deprecated',
        component: IEDeprecated,
        meta: { authStateRequired: 'either', title: 'Internet Explorer Deprecated' },
      },
      {
        path: '',
        name: 'signup-gate',
        component: SignupGate,
        children: [
          {
            path: '/verify-email',
            name: 'verify-email',
            component: VerifyEmail,
            meta: { title: 'Verify Email' },
          },
          {
            path: '/sso-locked',
            name: 'sso-locked',
            component: SsoLocked,
            meta: { title: 'SSO Locked' },
          },
          {
            path: '/disabled-user',
            name: 'disabled-user',
            component: DisabledUser,
            meta: { title: 'Disabled User' },
          },
          {
            path: '/project-not-assigned',
            name: 'project-not-assigned',
            component: ProjectNotAssigned,
            meta: { title: 'Project Not Assigned' },
          },
          {
            path: '/terminated-generic',
            name: 'terminated-generic',
            component: TerminatedGeneric,
            meta: { title: 'Ineligible' },
          },
          {
            path: '/terminated-hr-tech',
            name: 'terminated-hr-tech',
            component: TerminatedHrTech,
            meta: { title: 'Ineligible (HR Tech)' },
          },
          {
            path: '/terminated-no-ats',
            name: 'terminated-no-ats',
            component: TerminatedNoAts,
            meta: { title: 'Ineligible (No ATS)' },
          },
          {
            path: '/terminated-suspended',
            name: 'terminated-suspended',
            component: TerminatedSuspended,
            meta: { title: 'Ineligible (Suspended)' },
          },
          {
            path: '/trial-paused',
            name: 'trial-paused',
            component: TrialPaused,
            meta: { title: 'Trial Paused' },
          },
          {
            path: '/trial-expired',
            name: 'trial-expired',
            component: TrialExpired,
            meta: { title: 'Trial Expired' },
          },
          {
            path: '/trial-renew',
            name: 'trial-renew',
            component: TrialRenew,
            meta: { title: 'Trial Renew' },
          },
          {
            path: '/billing-expired',
            name: 'billing-expired',
            component: BillingExpired,
            meta: { title: 'Billing Expired' },
          },
          {
            path: '/account-on-hold',
            name: 'account-on-hold',
            component: SalesHold,
            meta: { title: 'Sales Hold' },
          },
          {
            path: '/technical-hold',
            name: 'technical-hold',
            component: TechnicalHold,
            meta: { title: 'Technical Hold' },
          },
          {
            path: '/account-being-setup',
            name: 'account-being-setup',
            component: AccountBeingSetup,
            meta: { title: 'Account Being Setup' },
          },
          {
            path: '/demo-request-hold',
            name: 'demo-request-hold',
            component: DemoRequestHold,
            meta: { title: 'Demo Request Hold' },
          },
          {
            path: '/maintenance',
            name: 'maintenance',
            component: Maintenance,
            meta: { authStateRequired: 'either', title: 'App Maintenance' },
          },
        ],
      },
      {
        path: '/create-password',
        name: 'create-password',
        props: true,
        component: CreatePassword,
        meta: { authStateRequired: 'either', title: 'Create Password' },
      },
      {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: { authStateRequired: 'either', title: 'Password Reset' },
      },
      {
        path: '/password-reset-success',
        name: 'password-reset-success',
        props: true,
        component: PasswordResetSuccess,
        meta: { authStateRequired: 'either', title: 'Password Reset Success' },
      },
      {
        path: '/about-your-company',
        name: 'about-your-company',
        component: AboutYourCompany,
        meta: { title: 'About Your Company' },
      },
      {
        path: '/terms-of-service/:id?',
        name: 'terms-of-service',
        component: TermsOfService,
        meta: { title: 'Terms of Service' },
      },
      {
        path: '/demo-request',
        name: 'demo-request',
        component: DemoRequest,
        meta: { authStateRequired: 'unauthenticated', title: 'Demo Request' },
      },
      {
        path: '/demo-provide-your-work-email',
        name: 'demo-provide-your-work-email',
        props: true,
        component: DemoProvideYourWorkEmail,
        meta: { title: 'Demo Provide Your Work Email' },
      },
      {
        path: '/demo-about-your-company',
        name: 'demo-about-your-company',
        props: true,
        component: DemoAboutYourCompany,
        meta: { title: 'Demo About Your Company' },
      },
      {
        path: '/demo-request-received',
        name: 'demo-request-received',
        props: true,
        component: DemoRequestReceived,
        meta: { authStateRequired: 'unauthenticated', title: 'Demo Request Received' },
      },
      {
        path: '/demo-ready',
        name: 'demo-ready',
        component: DemoReady,
        meta: { authStateRequired: 'either', title: 'Demo Ready' },
      },
    ],
  },
  {
    path: '/mobile-not-supported',
    name: 'mobile-not-supported',
    component: MobileNotSupported,
    meta: { authStateRequired: 'either', title: 'Mobile Not Supported' },
  },
];
